"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPathFromQuery = exports.generateNewId = void 0;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var generateNewId = exports.generateNewId = function generateNewId() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return array.length === 0 ? 1 : Math.max.apply(Math, _toConsumableArray(array.map(function (item) {
    return item.id;
  }))) + 1;
};
var getPathFromQuery = exports.getPathFromQuery = function getPathFromQuery(query) {
  if (!query) {
    return query;
  }

  // clean aliases
  var result = query.replace(/:\s*[\w\d]+\s*([({]+)/g, '$1');

  // remove funcion params
  result = result.replace(/\([^)]+\)/g, '');

  // remove brackets
  var bracketRegex = /\{([^}]+)\}/g;
  while (bracketRegex.test(result)) {
    result = result.replace(bracketRegex, '.$1');
  }
  result = result.replace(/\s*\.\s*/g, '.').trim();
  if (/\s/.test(result)) {
    throw new Error('Query should return only one value');
  }
  return result;
};